module.exports = __webpack_public_path__ + "img/boy.f0cd4076.png";